/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Temperature_MeasuredInputs */



/**
* | output |
* | --- |
* | "Valve(s) temperature" |
*
* @param {Temperature_MeasuredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const temperature_measured = /** @type {((inputs?: Temperature_MeasuredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Temperature_MeasuredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Valve(s) temperature")
	return /** @type {LocalizedString} */ ("Température tête(s) th.")
});